import React, { useState, useCallback } from 'react';
import { InputSearchProps } from './input-search-types';
import {
    SearchContainer,
    SearchInput,
    SearchIcon,
} from './style-component';
import searchIcon from '@/assets/icons/search/search.svg';
import searchDarkIcon from '@/assets/icons/search-dark/search-dark.svg';

import { debounce } from '@/utils/debounce/debounce';
import { useTheme } from '@/contexts/theme-context/useThemeContext';

export const InputSearch: React.FC<InputSearchProps> = ({
    placeholder = 'Buscar',
    onSearch,
    debounceMs = 300,
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearch = useCallback(
        (value: string) => {
            const debouncedFn = debounce((...args: unknown[]) => {
                const searchValue = args[0] as string;
                onSearch?.(searchValue);
            }, debounceMs);
            debouncedFn(value);
        },
        [onSearch, debounceMs]
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };

    const { theme } = useTheme();
    const isDark = theme.name === 'dark';

    return (
        <SearchContainer>
            <SearchIcon>
                <img src={isDark ? searchIcon : searchDarkIcon} alt="Search" />
            </SearchIcon>
            <SearchInput
                type="search"
                value={searchTerm}
                onChange={handleChange}
                placeholder={placeholder}
                aria-label="Search input"
            />
        </SearchContainer>
    );
};